var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "200",
        "height": "200",
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M512 0C229.236 0 0 229.236 0 512s229.236 512 512 512 512-229.236 512-512S794.764 0 512 0zm47.104 667.043c-37.841 0-73.449-20.899-85.69-44.637 0 0-20.34 82.478-24.67 98.397-7.26 26.903-21.27 53.76-34.257 75.031-18.525 24.204-39.89 6.237-42.45-15.825-.837-24.576.047-53.667 6.145-80.152 6.749-29.044 45.102-195.072 45.102-195.072s-11.217-22.853-11.217-56.645c0-53.062 30.115-92.672 67.63-92.672 31.884 0 47.29 24.483 47.29 53.76 0 32.721-20.433 81.687-30.952 127.022-8.797 37.981 18.665 68.934 55.342 68.934 66.42 0 111.198-87.133 111.198-190.324 0-78.476-51.759-137.17-145.92-137.17-106.357 0-172.638 80.99-172.638 171.427 0 31.186 8.984 53.202 23.134 70.19 6.47 7.82 7.4 10.985 5.026 19.969-1.675 6.61-5.538 22.435-7.121 28.718-2.327 9.077-9.542 12.288-17.548 8.937-49.012-20.434-71.82-75.218-71.82-136.75 0-101.702 84.015-223.652 250.601-223.652 133.865 0 221.976 98.91 221.976 205.08.046 140.52-76.428 245.434-189.161 245.434z"
      }
    })]));
  }
};